import { render, staticRenderFns } from "./global-search-container.vue?vue&type=template&id=0941b64b"
import script from "./global-search-container.vue?vue&type=script&lang=js"
export * from "./global-search-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports